import {
    CreateMatchPlayerCommandOfMatchPlayer,
    MatchCoachVm,
    MatchDetailVm,
    UpdateEventCommand,
} from '../../../../utils/api';
import MatchLogItem from './LogItem';

interface OwnProps {
    event: UpdateEventCommand;
    shootoutOrder?: number;
    shootoutControls?: React.ReactNode;
    match?: MatchDetailVm;
    lineups: CreateMatchPlayerCommandOfMatchPlayer[];
    lineup?: CreateMatchPlayerCommandOfMatchPlayer;
    isHomeTeam: boolean;
    coaches: MatchCoachVm[];
    editEvent: (event: UpdateEventCommand) => void;
    onRefereeMistakeChange: (eventId: number, value: number | null) => void;
}

export type Props = OwnProps;

export default MatchLogItem;
